import { render, staticRenderFns } from "./IndexableItem.vue?vue&type=template&id=ca666804&scoped=true"
import script from "./IndexableItem.vue?vue&type=script&lang=js"
export * from "./IndexableItem.vue?vue&type=script&lang=js"
import style0 from "./IndexableItem.vue?vue&type=style&index=0&id=ca666804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca666804",
  null
  
)

export default component.exports